import { render, staticRenderFns } from "./ModalVerComprobanteReversion.vue?vue&type=template&id=7972ee9e&scoped=true"
import script from "./ModalVerComprobanteReversion.vue?vue&type=script&lang=js"
export * from "./ModalVerComprobanteReversion.vue?vue&type=script&lang=js"
import style0 from "./ModalVerComprobanteReversion.vue?vue&type=style&index=0&id=7972ee9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7972ee9e",
  null
  
)

export default component.exports